import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import VueMeta from "vue-meta";
Vue.use(VueMeta, {
  refreshOnceOnNavigation: true
});

import "jquery";
import "bootstrap";
import "vue-owl-carousel";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";

Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);

//import db from "@/firebase/init-test.js";
import db from "@/firebase/init.js";
Vue.config.productionTip = true;
import Popper from "popper.js";
global.Popper = Popper;

import "./../node_modules/popper.js/dist/umd/popper.js";
import "./../node_modules/bootstrap/dist/js/bootstrap.min.js";
import "./../node_modules/bootstrap-vue/dist/bootstrap-vue.css";
import "./../node_modules/bootstrap-vue/dist/bootstrap-vue.js";

import "@/assets/css/bootstrap.min.css";
import "@/assets/css/style.css";

//date formater
Vue.use(require("vue-moment"));

//global filter
Vue.filter("trimFunction", function(val, count) {
  if (!val || typeof val != "string") return "";
  val = val.slice(0, count);
  return val;
});
// remove html tags
Vue.filter("stripHtmlTags", function(htmlcontent) {
  if (!htmlcontent) return "";
  let striptags = require("striptags");
  return striptags(htmlcontent);
});

//global constant to turn on or off firestore
Vue.prototype.$useFirestore = true;
Vue.filter("getFireStoreRecords", function(collectionName) {
  var FireStoreDataCollection = [];
  db.collection(collectionName)
    .get()
    .then(snapshots => {
      snapshots.forEach(doc => {
        let firestore_item = doc.data();
        firestore_item.id = doc.id;
        FireStoreDataCollection.push(firestore_item);
      });
      console.log(FireStoreDataCollection);
    })
    .catch(err => {
      console.log(err);
      return "";
    });
  return FireStoreDataCollection;
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
